import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';

import { PublicRestService } from '@generated/be';
import { publicApiArgs } from '@shared/utils';

@Component({
  selector: 'reza-warning-text-field',
  imports: [],
  templateUrl: './warning-text-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarningTextFieldComponent implements OnInit {
  private publicService = inject(PublicRestService);
  private cd = inject(ChangeDetectorRef);

  textUpozorneni: string | undefined = undefined;

  ngOnInit(): void {
    this.publicService.vypisUpozorneni(...publicApiArgs()).subscribe((res) => {
      this.textUpozorneni = res.popisUpozorneni;
      this.cd.detectChanges();
    });
  }
}
